import React from 'react';

interface IntroScreenHeaderProps {
  title: string;
  description: string;
}

export function IntroScreenHeader({ title, description }: IntroScreenHeaderProps) {
  return (
    <>
      <div className="screen-header">
        <h2>{title}</h2>
      </div>
      <div className="section-overview">
        <p>
          {description}
        </p>
      </div>
    </>
  );
}
